import React, { useState, useEffect, useContext } from "react";
import Pagination from "../../../../libs/Pagination";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../libs/LoadingSpinner";
import { getAllChat } from "../../../../libs/api/chatApi";
import { AppContext } from "../../../../context/appContext";


export default function Chat() {
  const { t, formatNum, isRTL, formatDateTimeStr } = useContext(AppContext);

  const [sessions, setSessions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    fetchSessions(true);
  }, [currentPage, limit]);

  const fetchSessions = async (isLoading) => {
    setLoading(isLoading);
    try {
      const response = await getAllChat(currentPage, limit);
      if (response.status === 200) {
        setSessions(response?.data?.data || []);
        setTotalPages(response.data.totalPages || 1);
        setLimit(response.data.limit || 10);
        setCurrentPage(response.data.currentPage || 1);
        setTotalRecords(response.data.totalRecords || 0);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || t('messages.somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  }


  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return formatDateTimeStr(dateString);
  };

  return (
    <div className={`p-6 ${isRTL ? 'rtl' : 'ltr'}`}>
      <h2 className="text-2xl font-semibold mb-4">{t('chat.sessions')}</h2>

      <div className="bg-white rounded-3xl shadow">
        {/* Table */}

        <div className="w-full">
          {/* Table Header */}
          <div className="bg-[#FAFAFA] text-sm font-[600] grid grid-cols-5 border-b border-[#F7F7F9]">
            <div className={`p-2 py-4 ${isRTL ? 'pr-8' : 'pl-8'}`}>{t('common.id')}</div>
            <div className="p-2 py-4">{t('chat.sessionId')}</div>
            <div className="p-2 py-4">{t('chat.type')}</div>
            <div className="p-2 py-4">{t('chat.ipAddress')}</div>
            <div className="p-2 py-4">{t('chat.createdAt')}</div>
          </div>

          {loading && <div className="flex justify-center items-center h-full p-6"><LoadingSpinner /></div>}
          {!loading && sessions.length === 0 && (
            <div className="flex justify-center items-center h-full p-6">
              <p className="text-gray-500">{t('chat.noSessions')}</p>
            </div>
          )}

          {/* Draggable Content */}
          {!loading && sessions.length > 0 && (
            <div>
              {sessions.map((session, index) => (
                <div
                  key={session._id}
                  className={`grid grid-cols-5 hover:bg-gray-50 border-b border-[#efeff1] text-sm font-[500] select-none `}

                >
                  <div className={`p-2 py-6 ${isRTL ? 'pr-8' : 'pl-8'} flex items-center gap-2`}>
                    {formatNum((currentPage - 1) * limit + index + 1)}
                  </div>
                  <div className="p-2 py-6">{session?.sessionId || "-"}</div>
                  <div className="p-2 py-6">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${session?.type === 'api' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                      }`}>
                      {session?.type === 'api' ? t('chat.api') : t('chat.web')}
                    </span>
                  </div>
                  <div className="p-2 py-6">{session?.ipAddress || "-"}</div>
                  <div className="p-2 py-6">{formatDate(session?.createdAt)}</div>

                </div>
              ))}
            </div>
          )}
        </div>

        {/* Pagination */}
        {sessions.length > 0 && (
          <div className="flex justify-between items-center p-6 border-t border-[#F7F7F9] text-sm text-gray-600">
            <span>
              {t('pagination.showing')} {formatNum((currentPage - 1) * limit + 1)} {t('pagination.to')} {formatNum(Math.min(currentPage * limit, totalRecords))} {t('pagination.of')} {formatNum(totalRecords)} {t('pagination.entries')}
            </span>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>

    </div>
  );
}